<template>
  <div class="content flex-box" v-if="activity">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-guest"
      entity-name="嘉宾/随行人员"
      add-btn="添加嘉宾"
      hide-show-detail
      :hide-action="!editable"
      :deal-list="dealList"
      :custom-url="customUrl"
      :before-edit="beforeEdit"
      :before-update="beforeUpdate"
      :query="query"
      :action="action"
      :columns="columns"
      :rules="rules"
      :row-selection="rowSelection"
      :action-width="300"
      :modal-width="640"
      :modal-form="modalForm">
      <template v-slot:button v-if="editable">
        <a-button @click="importGuest(1)"><a-icon type="upload" />批量导入</a-button>
        <a-button type="primary" @click="sendSms">发送短信</a-button>
      </template>
      <template v-slot:action="{item}">
        <a class="txt-btn" @click="audit(item)">审核</a>
        <br/>
        <a class="txt-btn" @click="addEntourage(item)" style="margin-left: 0">添加随行人员</a>
        <a class="txt-btn" @click="setReceptionist(item)">设置接待人员</a>
      </template>
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input v-model="form.keyword" placeholder="输入嘉宾姓名或手机号查询" style="width: 200px"></a-input>
        </a-form-model-item>
      </template>
      <template v-slot:edit="{form}">
        <div class="form-area-title" v-if="form.type == 2 && guest && guest.id == form.f_id">随行嘉宾：{{guest.name}}</div>
        <a-form-model-item label="姓名" prop="name">
          <a-input v-model="form.name" placeholder="请输入姓名" :disabled="!!form.formType"></a-input>
        </a-form-model-item>
        <a-form-model-item label="手机号码" prop="tel">
          <a-input v-model="form.tel" placeholder="请输入手机号码" :disabled="!!form.formType"></a-input>
        </a-form-model-item>
        <a-form-model-item label="性别" prop="sex">
          <a-select v-model="form.sex" placeholder="请选择性别" :options="genderList" :disabled="form.formType == 'rec'"></a-select>
        </a-form-model-item>
        <a-form-model-item label="身份" prop="identity" v-if="form.formType == 'audit'">
          <a-select v-model="form.identity" placeholder="请选择身份" :options="identityOptions"></a-select>
        </a-form-model-item>
        <a-form-model-item label="接待人员" prop="receptionist" v-if="form.formType == 'rec'">
          <select-person v-model="form.receptionist" multiple :type="3" :activity="activity.id"></select-person>
        </a-form-model-item>
        <template v-if="!form.formType">
          <a-form-model-item label="证件类型" prop="id_type">
            <a-select v-model="form.id_type" placeholder="请选择证件类型" :options="guestIdTypeList"></a-select>
          </a-form-model-item>
          <a-form-model-item label="证件号码" prop="id_num">
            <a-input v-model="form.id_num" placeholder="请输入证件号码"></a-input>
          </a-form-model-item>
          <div class="form-area-title">到达信息</div>
          <a-form-model-item label="到达方式" prop="arrival_method">
            <a-select v-model="form.arrival_method" placeholder="请选择到达方式" :options="guestWayTypeList"></a-select>
          </a-form-model-item>
          <a-form-model-item label="航班/车次" prop="arrival_number" v-if="form.arrival_method == 1 || form.arrival_method == 2">
            <a-input v-model="form.arrival_number" placeholder="请输入航班/车次"></a-input>
          </a-form-model-item>
          <a-form-model-item label="车牌号" prop="arrival_driver" v-if="form.arrival_method == 3">
            <a-input v-model="form.arrival_driver" placeholder="请输入车牌号"></a-input>
          </a-form-model-item>
          <template v-else>
            <a-form-model-item label="到达时间" prop="arrival_time">
              <a-date-picker
                show-time
                value-format="yyyy-MM-DD HH:mm:ss"
                v-model="form.arrival_time"
                placeholder="请选择到达时间"
                style="width: 100%"/>
            </a-form-model-item>
            <a-form-model-item label="到达地址" prop="arrival_address">
              <a-input v-model="form.arrival_address" placeholder="请输入到达地址"></a-input>
            </a-form-model-item>
          </template>
          <div class="form-area-title">离开信息</div>
          <a-form-model-item label="离开方式" prop="leave_method">
            <a-select v-model="form.leave_method" placeholder="请选择离开方式" :options="guestWayTypeList"></a-select>
          </a-form-model-item>
          <a-form-model-item label="航班/车次" prop="leave_number" v-if="form.leave_method == 1 || form.leave_method == 2">
            <a-input v-model="form.leave_number" placeholder="请输入航班/车次"></a-input>
          </a-form-model-item>
          <a-form-model-item label="车牌号" prop="leave_driver" v-if="form.leave_method == 3">
            <a-input v-model="form.leave_driver" placeholder="请输入车牌号"></a-input>
          </a-form-model-item>
          <template v-else>
            <a-form-model-item label="出发时间" prop="leave_time">
              <a-date-picker
                show-time
                value-format="yyyy-MM-DD HH:mm:ss"
                v-model="form.leave_time"
                placeholder="请选择出发时间"
                style="width: 100%"/>
            </a-form-model-item>
            <a-form-model-item label="出发地址" prop="leave_address">
              <a-input v-model="form.leave_address" placeholder="请输入出发地址"></a-input>
            </a-form-model-item>
          </template>
        </template>
      </template>
      <template v-slot:expandedRowRender="guest">
        <a-table
          row-key="id"
          :show-header="false"
          :columns="innerColumns"
          :data-source="guest.entourage"
          :pagination="false"
          :locale="{emptyText: '暂无随行人员'}">
          <template v-slot:action="text, record">
            <div class="row-btn">
              <a class="txt-btn" @click.stop="editEntourage(record, guest)">编辑</a>
              <a class="txt-btn danger" @click.stop="deleteEntourage(record, guest)">删除</a>
              <a class="txt-btn" @click.stop="audit(record, guest)">审核</a>
            </div>
          </template>
        </a-table>
      </template>
    </data-list>
    <batch-import-modal
      v-model="visible"
      :name="importConfig.name"
      :url="importConfig.url"
      :import-url="importConfig.importUrl"
      :activity="activity.id * 1"
      @import="handleImport"></batch-import-modal>
  </div>
</template>

<script>
    import {genderList, getGenderText, getGuestAuditStatusText, guestWayTypeList, guestIdTypeList} from "../../../common/activity/guest";
    import batchImportModal from "../../../components/batch-import-modal";
    import {omit} from "../../../common/js/tool";
    import mixins from "../mixins";

    export default {
        name: "GuestVerify",
        components: {
            batchImportModal
        },
        data() {
            return {
                columns: [
                    {title: '姓名', dataIndex: 'name', width: 80},
                    {title: '随行人员', dataIndex: 'entourage', width: 100, customRender: text => text && text.length > 0 ? `${text.length}人` : '无'},
                    {title: '性别', dataIndex: 'sex', width: 60, customRender: text => getGenderText(text)},
                    {title: '手机号码', dataIndex: 'tel', width: 120},
                    {title: '身份标识', dataIndex: 'guestImg', width: 100, customRender: text => text ? text.level: '未设置'},
                    {title: '审核状态', dataIndex: 'audit_status', width: 100, customRender: text => getGuestAuditStatusText(text)},
                    {title: '报名方式', dataIndex: 'enroll_status', width: 100, customRender: text => text == 2 ? '人工报名' : '线上报名'},
                    {title: '填报状态', dataIndex: 'fill_status', width: 100, customRender: text => text == 2 ? '已填报' : '未填报'},
                    {title: '接待人员', dataIndex: 'receptionist', width: 200, customRender: text => text && text.length > 0 ? text.map(r => r.name).join(" ") : '--'},
                ],
                rules: {
                    name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                    tel: [
                        { required: true, message: '请输入手机号码', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ],
                    sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
                    id_type: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
                    id_num: [{ required: true, message: '请输入证件号码', trigger: 'blur' }],
                    identity: [{ required: true, message: '请选择身份', trigger: 'change' }],
                    receptionist: [{ required: true, message: '请添加接待人员', trigger: 'change' }],
                    arrival_method: [{ required: true, message: '请选择到达方式', trigger: 'change' }],
                    arrival_number: [{ required: true, message: '请输入航班/车次', trigger: 'blur' }],
                    arrival_driver: [{ required: true, message: '请输入车牌号', trigger: 'blur' }],
                    arrival_time: [{ required: true, message: '请选择到达时间', trigger: 'change' }],
                    arrival_address: [{ required: true, message: '请输入到达地址', trigger: 'blur' }],
                    arrival_transfer: [{ required: true, message: '请选择到达是否安排接送', trigger: 'change' }],
                    leave_method: [{ required: true, message: '请选择离开方式', trigger: 'change' }],
                    leave_number: [{ required: true, message: '请输入航班/车次', trigger: 'blur' }],
                    leave_driver: [{ required: true, message: '请输入车牌号', trigger: 'blur' }],
                    leave_time: [{ required: true, message: '请选择出发时间', trigger: 'change' }],
                    leave_address: [{ required: true, message: '请输入出发地址', trigger: 'blur' }],
                    leave_transfer: [{ required: true, message: '请选择出发是否安排接送', trigger: 'change' }],
                    eat_type: [{ required: true, message: '请选择是否用餐', trigger: 'change' }],
                    live_type: [{ required: true, message: '请选择是否住宿', trigger: 'change' }],
                },
                genderList,
                guestIdTypeList,
                guestWayTypeList,
                guestImgList: [],
                identityOptions: [],
                guest: null,
                visible: false,
                modalForm: {
                    labelAlign: 'right',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                },
                importType: 1,
                selectedRows: [],
                moduleKey: 'guest-invite',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '&expand=children,guestImg,receptionist&filter[f_id]=0';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            },
            innerColumns() {
                const res = [
                    {title: '嘉宾', dataIndex: 'guest', width: 80},
                    {title: '姓名', dataIndex: 'name', width: 100},
                    {title: '性别', dataIndex: 'sex', width: 60, customRender: text => getGenderText(text)},
                    {title: '手机号码', dataIndex: 'tel', width: 120},
                    {title: '身份标识', dataIndex: 'guestImg', width: 100, customRender: text => text ? text.level: '随行人员'},
                    {title: '审核状态', dataIndex: 'audit_status', width: 100, customRender: text => getGuestAuditStatusText(text)},
                    {title: '报名方式', dataIndex: 'enroll_status', width: 100, customRender: text => text == 2 ? '人工报名' : '线上报名'},
                    {title: '填报状态', dataIndex: 'fill_status', width: 100, customRender: text => text == 2 ? '已填报' : '未填报'},
                    {title: '接待人员', dataIndex: 'receptionist', width: 200, customRender: () => '--'},
                ]
                if(this.editable) {
                    res.push({title: '操作', key: 'action', width: 300, scopedSlots: { customRender: 'action'}})
                }
                return res;
            },
            importConfig() {
                const importType = this.importType;
                let res = {};
                if(importType == 1) {
                    res = {
                        name: '嘉宾信息导入模板.xlsx',
                        url: 'https://zk-static-1301841918.cos.ap-nanjing.myqcloud.com/wb/activity/assets/guest_info_template.xlsx',
                        importUrl: '/activity/activity-guest/process-import'
                    }
                } else {
                    res = {
                        name: '随行人员导入模板.xlsx',
                        url: 'https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/assets/activity/template/entourage_template.xlsx',
                        importUrl: '/activity/activity-guest/sui-import'
                    }
                }
                return res;
            },
            selectedRowKeys() {
                return this.selectedRows.map(item => item.id)
            },
            rowSelection() {
                return this.editable ? {
                    selectedRowKeys: this.selectedRowKeys,
                    onChange: this.onSelectChange
                } : null
            }

        },
        created() {
            this.getGuestImg();
        },
        methods: {
            sendSms() {
                const list = this.selectedRows;
                if(list.length > 0) {
                    this.$confirm({
                        title: `确定给下列${list.length}人发送短信吗？`,
                        content: <div>{list.map(g => g.name).join("、")}</div>,
                        onOk: () => {
                            const url = "/activity/activity-guest/send-msg";
                            this.$axios({
                                url,
                                method: 'POST',
                                data: {
                                    id: list.map(item => item.id).join(",")
                                }
                            }).then(res => {
                                if(res.error == 0) {
                                    this.$message.success('已发送');
                                } else {
                                    this.$message.warning(res.msg || '发送失败');
                                }
                            });
                        },
                    });
                } else {
                    this.$message.warning("请选择嘉宾");
                }
            },
            onSelectChange(keys, rows) {
                this.selectedRows = rows;
            },
            setReceptionist(item) {
                this.$refs.dataList.showEdit({
                    formType: 'rec',
                    id: item.id,
                    name: item.name,
                    tel: item.tel,
                    sex: item.sex,
                    receptionist: [...(item.receptionist || [])]
                });
            },
            audit(item, guest) {
                if(item.fill_status == 2) {
                    const identityOptions = [...this.guestImgList];
                    if(guest) {
                        identityOptions.push({key: 0, title: '随行人员'});
                    }
                    this.identityOptions = identityOptions;
                    this.$refs.dataList.showEdit({
                        formType: 'audit',
                        identity: item.guest_img_id || (guest ? 0 : undefined),
                        id: item.id,
                        name: item.name,
                        tel: item.tel,
                        sex: item.sex,
                    });
                } else {
                    this.$warning({
                        title: '提示',
                        content: '该人员未填报，请联系嘉宾填报信息后审核',
                    });
                }
            },
            deleteEntourage(entourage, guest) {
                this.$confirm({
                    title: "提示",
                    content: '确定删除此随行人员吗？',
                    onOk: () => {
                        let url = `/activity/activity-guest/${entourage.id}`;
                        this.$axios({
                            url,
                            method: "DELETE",
                        }).then(() => {
                            this.$message.success("已删除");
                            const children = guest.children;
                            const index = children.findIndex(e => e.id == entourage.id);
                            if(index >= 0) {
                                children.splice(index, 1);
                            }
                        });
                    },
                    onCancel: () => {},
                });
            },
            addEntourage(guest) {
                this.guest = guest;
                this.$refs.dataList.showEdit({
                    type: 2,
                    f_id: guest.id
                });
            },
            editEntourage(entourage, guest) {
                const form = {...entourage};
                this.guest = guest;
                this.$refs.dataList.showEdit(form);
            },
            getGuestImg() {
                const url = '/activity/activity-guest-img?pageSize=1000';
                this.$axios(url).then(res => {
                    const guestImgList = res.data.map(item => new Object({key: item.id, title: item.level}));
                    // guestImgList.push({key: 0, title: '随行人员'});
                    this.guestImgList = guestImgList;
                });
            },
            beforeEdit(form, fn) {
                if(!form.id && !form.type) {
                    form.type = 1;
                }
                fn();
            },
            dealList(list, fn) {
                fn(list.map(item => {
                    item.entourage = item.children;
                    delete item.children;
                    return {...item};
                }));
            },
            customUrl(form) {
                let res = '';
                if(form.keyword) {
                    res = `&filter[or][0][name][like]=${form.keyword}&filter[or][1][tel][like]=${form.keyword}`;
                }
                return res;
            },
            beforeUpdate(form, fn) {
                let data = {...form};
                if(form.formType == 'audit') {
                    data = {
                        id: form.id,
                        guest_img_id: form.identity == 0 ? null : form.identity,
                        audit_status: 2
                    }
                } else if(form.formType == 'rec') {
                    data = {
                        id: form.id,
                        receptionist_id: form.receptionist.map(item => item.id).join(",")
                    }
                } else {
                    if(!form.id) {
                        data.activity_id = this.activity.id;
                    } else {
                        data = omit(form, ['accompany_info', 'entourage', 'guestImg', 'receptionist'])
                    }
                    data.enroll_status = 2;
                    data.fill_status = 2;
                }
                fn(data);
            },
            importGuest(type) {
                this.importType = type;
                this.visible = true;
            },
            handleImport() {
                this.visible = false;
                this.$refs.dataList.getList();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
